<template>
  <div :class="classes">
    <pt-page-title title="节假日管理" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="name">
        <template slot="before-left">
          <el-button type="primary" @click="createdHoliday">新建节假日</el-button>
          <el-button type="primary" @click="createdHolidayLot">批量创建节假日</el-button>
        </template>
    </pt-page-title>
    <pt-page-factor-filter :labels="filterLabels" v-model="filterCondition" @Filter="Filter" ref="filter">
      <template>
          <el-button type="primary" @click="Filter()">筛选</el-button>
          <el-button type="primary" @click="deleteDays">批量删除</el-button>
          <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
        </template>
    </pt-page-factor-filter>
    <div :class="$style['table-content']">
      <div :class="$style['holiday-table']">
        <year-month-select v-model="currentSelect"></year-month-select>
        <pt-holiday-table :params-data="paramsData" ref="tableWithData"  :isFromRouter="isFromRouter" @updateSelectedData="updateSelectedData" @updateTableData="updateTableData">
          <el-table-column label="操作" min-width="100px" fixed="right">
              <div slot-scope="scope" :class="$style['opreation-button']">
                <el-button type="text" @click="goEdit(scope.row)">编辑</el-button>
                <el-button type="text" @click="deleteDay(scope.row)">删除</el-button>
              </div>
          </el-table-column>
        </pt-holiday-table>
      </div>
      <holiday-calendar :class="$style['holiday-calendar']" v-model="currentCalendar" :holidays="holidays"></holiday-calendar>
    </div>
  </div>
</template>

<script>
import yearMonthSelect from './year-month-select'
import ptHolidayTable from './pt-holiday-table/withData'
import holidayCalendar from './holiday-calendar'
import { filterLabels } from './holiday-option.js'
import {
  emptyObject
} from '@/utils/lifebankUtils'
import { formatZero } from '@/utils/formUtils'
// 组件class前缀
const prefixCls = 'pt-holiday-manage'

export default {
  name: 'pt-holiday-manage',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptHolidayTable,
    holidayCalendar,
    yearMonthSelect
  },
  data () {
    return {
      filterLabels: filterLabels,
      filterCondition: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1
      },
      params: {},
      paramsData: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1
      },
      isFromRouter: false,
      name: '',
      currentSelect: null,
      currentCalendar: new Date(),
      selected: [],
      holidays: []
    }
  },
  watch: {
    currentSelect (val, old) {
      if (val !== old) {
        this.paramsData.year = val.year
        this.paramsData.month = val.month
        this.changeCalendar()
      }
    }
  },
  methods: {
    load () {
      this.reset()
      this.$refs.tableWithData.load()
    },
    reset () {
      this.filterCondition = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1
      }
      this.paramsData = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1
      }
      this.currentCalendar = new Date()
      this.currentSelect = this.filterCondition
      this.cleanParams()
    },
    changeCalendar () {
      let year = this.currentSelect ? this.currentSelect.year : new Date().getFullYear()
      let month = this.currentSelect ? this.currentSelect.month : new Date().getMonth() + 1
      let day = new Date().getDay()
      let date = [year, formatZero(month, 2), formatZero(day, 2)].join('-')
      this.currentCalendar = new Date(date)
    },
    createdHoliday () {
      this.$router.push(`/holiday-manage/${this.$route.meta.type}/holiday-form/false/0`)
    },
    createdHolidayLot () {
      this.$router.push(`/holiday-excel-new/${this.$route.meta.type}`)
    },
    search (val) {
      this.name = val
      this.isFromRouter = false
      emptyObject(this.params)
      emptyObject(this.paramsData)
      this.$set(this.params, 'name', val)
      this.$set(this.paramsData, 'name', val)
    },
    emptySearch (val) {
      this.name = null
      this.$delete(this.paramsData, 'name')
    },
    cleanParams () {
      this.$delete(this.paramsData, 'holidayTypes')
      this.$delete(this.filterCondition, 'holidayTypes')
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      if (!this.filterCondition.year) {
        this.$message.error('必须选择一个年份进行筛选！')
        return
      }
      if (!this.filterCondition.month) {
        this.$message.error('必须选择一个月份进行筛选！')
        return
      }
      for (let key in this.filterCondition) {
        if (!this.filterCondition[key]) {
          this.$delete(this.filterCondition, key)
        }
      }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.filterCondition)
      }
      this.paramsData = { ...this.filterCondition }
      let { year, month } = this.paramsData
      this.currentSelect = { year, month }
      console.log('----', this.currentSelect)
    },
    goEdit (row) {
      this.$router.push(`/holiday-manage/${this.$route.meta.type}/holiday-form/true/${row.id}`)
    },
    updateSelectedData (rows) {
      this.selected = rows
    },
    updateTableData (datas) {
      this.holidays = datas
    },
    deleteDays () {
      this.$confirm(`确定要删除${this.selected.length}个节假日?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let api
        switch (this.$route.meta.type) {
          case 'gene':
            api = 'deleteHolidays'
            break
          case 'sign':
            api = 'deleteHolidaysOfSign'
            break
          default:
            api = 'deleteAdultHolidays'
            break
        }
        // let api = this.$route.meta.type === 'gene' ? 'deleteHolidays' : 'deleteAdultHolidays'
        this.$store.dispatch(api, this.selected.map(e => e.id)).then(data => {
          this.$refs.tableWithData.load()
          this.$message.success('删除成功！')
        }).catch(err => {
          this.$message.error(err)
        })
      })
    },
    deleteDay (row) {
      let date = [row.year, formatZero(row.month, 2), formatZero(row.day, 2)].join('-')
      this.$confirm(`确定要删除节假日：${date}${row.name}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let api
        switch (this.$route.meta.type) {
          case 'gene':
            api = 'deleteHoliday'
            break
          case 'sign':
            api = 'deleteHolidayOfSign'
            break
          default:
            api = 'deleteAdultHoliday'
            break
        }
        // let api = this.$route.meta.type === 'gene' ? 'deleteHoliday' : 'deleteAdultHoliday'
        this.$store.dispatch(api, row.id).then(data => {
          this.$refs.tableWithData.load()
          this.$message.success('删除成功！')
        }).catch(err => {
          this.$message.error(err)
        })
      })
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.table-content{
  display: flex;
  .holiday-table{
    width: 50%;
  }
  >.holiday-calendar{
    max-width: 700px;
    margin-left:50px;
  }
}
</style>
